<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
html,body,#app {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  
  .auto-img {
    width:100%;
    display: block;
  }
 

}
</style>



// WEBPACK FOOTER //
// src/App.vue